import getUnixTime from 'date-fns/getUnixTime';

/**
 * @deprecated Use the `dateHelpers` class calling `timestamp` or `timestampInSeconds` method instead.
 */
export const getUnixTimestamp = (date: Date = new Date()): number => getUnixTime(date);
export const getUnixTimestampInMilliseconds = (date: Date = new Date()): number => date.valueOf();

export default getUnixTimestamp;
